document.addEventListener('DOMContentLoaded', function () {
  initColorSwatches();
});

function initColorSwatches() {
  const swatchContainers = document.querySelectorAll('.color-swatches');

  swatchContainers.forEach(function (container) {
    const swatches = container.querySelectorAll('.color-swatch');

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function (e) {
        const isProductPage = container.dataset.context === 'product-page';
        if (isProductPage) return;
        e.preventDefault();

        const productCard = container.closest('product-card');
        if (!productCard) return;

        const featuredImage = swatch.dataset.featuredImage;
        const hoverImage = swatch.dataset.hoverImage;
        const productUrl = swatch.dataset.productUrl;

        // Update active swatch
        swatches.forEach(function (s) {
          s.classList.remove('color-swatch--active');
        });
        swatch.classList.add('color-swatch--active');

        // Update first slide image
        const slides = productCard.querySelectorAll('slideshow-slide');
        if (slides[0]) {
          const img = slides[0].querySelector('.product-media__image');
          if (img && featuredImage) {
            img.dataset.originalSrc = img.dataset.originalSrc || img.src;
            img.src = featuredImage;
            img.srcset = featuredImage;
          }
        }

        // Update second slide image
        if (slides[1]) {
          const img2 = slides[1].querySelector('.product-media__image');
          if (img2 && hoverImage) {
            img2.dataset.originalSrc = img2.dataset.originalSrc || img2.src;
            img2.src = hoverImage;
            img2.srcset = hoverImage;
          }
        }

        // Update all card links
        const cardLinks = productCard.querySelectorAll('a[ref="cardGalleryLink"], a[ref="productCardLink"], a[ref="productTitleLink"]');
        cardLinks.forEach(function (link) {
          link.href = productUrl;
        });
      });

      // Hover — preview image
      swatch.addEventListener('mouseenter', function () {
        const productCard = container.closest('product-card');
        if (!productCard) return;

        const featuredImage = swatch.dataset.featuredImage;
        const img = productCard.querySelector('.product-media__image');
        if (img && featuredImage) {
          img.dataset.originalSrc = img.dataset.originalSrc || img.src;
          img.src = featuredImage;
          img.srcset = featuredImage;
        }
      });

      // Mouse leave — restore unless this swatch is active
      swatch.addEventListener('mouseleave', function () {
        const productCard = container.closest('product-card');
        if (!productCard) return;

        if (swatch.classList.contains('color-swatch--active')) return;

        const img = productCard.querySelector('.product-media__image');
        if (img && img.dataset.originalSrc) {
          img.src = img.dataset.originalSrc;
          img.srcset = img.dataset.originalSrc;
        }
      });
    });
  });
}